export const formatDate = (timestamp: number, locale = 'en-US') => {
  return new Date(timestamp * 1000).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export const formatExpirationDate = (date: string) => {
  const expirationDate = new Date(date)
  const now = new Date()
  const diffDays = Math.ceil((expirationDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))

  if (diffDays < 0) {
    return 'Invitation expired'
  } else if (diffDays === 0) {
    return 'Invitation expires today'
  } else if (diffDays === 1) {
    return 'Invitation expires tomorrow'
  } else if (diffDays > 30) {
    return `Invitation expires in ${Math.floor(diffDays / 30)} months`
  } else {
    return `Invitation expires in ${diffDays} days`
  }
}

// Duplicated in desktop
export function calculateTrialDays(trialEndsAt: number): number {
  const trialEndTimestamp = !trialEndsAt || !Number.isFinite(trialEndsAt) ? 0 : trialEndsAt * 1000
  const differenceInDays = Math.max(0, Math.ceil((trialEndTimestamp - Date.now()) / (1000 * 60 * 60 * 24)))

  return differenceInDays
}

export const DAY_MS = 86_400_000

/** UTC calendar day, YYYY-MM-DD. */
export const utcDay = (value: number | string | Date) => new Date(value).toISOString().slice(0, 10)

const UTC_DATE_TIME = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZone: 'UTC',
  timeZoneName: 'short',
})

/** e.g. "Oct 23, 2026, 10:42 PM UTC". */
export const formatUtcDateTime = (value: string) => UTC_DATE_TIME.format(new Date(value))
